/**
 * ChannelsChoiceDescription component.
 */
import ChannelChoiceDescription from '@components/atoms/text/channelChoiceDescription';
import ChannelChoiceTitle from '@components/atoms/text/channelChoiceTitle';
import DescriptionChoiceContainer from '@components/atoms/container/descriptionChoiceContainer';
import TranslationManager from '@shared/assets/locale/translationsManager';

/**
 * Displays the title and description of the channels choice page.
 */
export default function ChannelsChoiceDescription() {
  return (
    <DescriptionChoiceContainer>
      <ChannelChoiceTitle>
        {TranslationManager.get('PAGES.CHANNELS_CHOICE.TITLE')}
      </ChannelChoiceTitle>
      <ChannelChoiceDescription
        dangerouslySetInnerHTML={{
          __html: TranslationManager.get('PAGES.CHANNELS_CHOICE.DESCRIPTION'),
        }}
      />
    </DescriptionChoiceContainer>
  );
}
